// axiosInstance/invoices.js

import { axiosInstance } from "@/api/axiosInstance";

export const invoicesService = {
    getInvoices: async (page = 0, size = 20, userId, companyId, search, status, awaitingReview) => {
        const response = await axiosInstance.get("/invoices/get-all", {
            params: {
                page,
                size,
                ...(userId && { userId }),
                ...(companyId && { companyId }),
                ...(search && { search }),
                ...(status && { status }),
                ...(awaitingReview && { awaitingReview })
            }
        });            return response.data;
    },
    // Invoices billed to the current user or to their company; the backend works out who that is
    getMyInvoices: async (page = 0, size = 20, search, status, awaitingReview) => {
        const response = await axiosInstance.get("/invoices/mine", {
            params: {
                page,
                size,
                ...(search && { search }),
                ...(status && { status }),
                ...(awaitingReview && { awaitingReview })
            }
        });
        return response.data;
    },
    getInvoice: async (id) => {
            const response = await axiosInstance.get(`/invoices/${id}`);
            return response.data;
    },

    createInvoice: async (invoiceData) => {
            const response = await axiosInstance.post("/invoices/add", invoiceData);
            return response.data;
    },
    createSurveyInvoice: async (invoiceData) => {
            const response = await axiosInstance.post("/invoices/create-survey-invoice", invoiceData);
            return response.data;
    },

    updateInvoice: async (id, invoiceData) => {
            const response = await axiosInstance.put(`/invoices/update/${id}`, invoiceData);
            return response.data;
    },

    deleteInvoice: async (id) => {
            const response = await axiosInstance.delete(`/invoices/${id}`);
            return response.data;
    },

    updateStatus: async (id, status) => {
            const response = await axiosInstance.patch(`/invoices/${id}/status`, null, {params: { status }
            });
            return response.data;
    },

    // Bank transfer: the client uploads a proof of payment, an admin accepts or rejects it
    getPaymentProofs: async (invoiceId) => {
        const response = await axiosInstance.get(`/invoices/${invoiceId}/payment-proofs`);
        return response.data;
    },

    uploadPaymentProof: async (invoiceId, file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await axiosInstance.post(`/invoices/${invoiceId}/payment-proofs`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    },

    acceptPaymentProof: async (proofId) => {
        const response = await axiosInstance.patch(`/invoices/payment-proofs/${proofId}/accept`);
        return response.data;
    },

    rejectPaymentProof: async (proofId, reason) => {
        const response = await axiosInstance.patch(`/invoices/payment-proofs/${proofId}/reject`, { reason });
        return response.data;
    },

    deleteInvoiceItem: async (invoiceId, itemId) => {
            const response = await axiosInstance.delete(`/invoices/${invoiceId}/items/${itemId}`);
            return response.data;
    },
    markAsPaid: async (id, paymentMethod, transactionId) => {
        const response = await axiosInstance.post(`/invoices/${id}/pay`, {
            paymentMethod,
            transactionId,
            paymentDate: new Date().toISOString()
        });
        return response.data;
    },
    sendEmailWithAttachment: async (formData) => {
            const response = await axiosInstance.post(`/invoices/${formData.get('invoiceId')}/send-email`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;

    }
};
